import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type {
  Pageable,
  WrapperPageableResponseEntityChangeDTO,
  WrapperResponseEntityAuditCompareDTO
} from '../core/models';

export interface EntityAuditSearchParams {
  entityType?: string | null;
  entityId?: number | null;
  author?: string | null;
  from?: string | null;
  to?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class EntityAuditService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  search(
    filters: EntityAuditSearchParams = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseEntityChangeDTO> {
    let params = new HttpParams()
      .set('page', String(pageable.page))
      .set('size', String(pageable.size));
    if (filters.entityType) {
      params = params.set('entityType', filters.entityType);
    }
    if (filters.entityId != null) {
      params = params.set('entityId', String(filters.entityId));
    }
    if (filters.author) {
      params = params.set('author', filters.author);
    }
    if (filters.from) {
      params = params.set('from', filters.from);
    }
    if (filters.to) {
      params = params.set('to', filters.to);
    }
    return this.http.get<WrapperPageableResponseEntityChangeDTO>(`${this.apiUrl}/audit`, { params });
  }

  getChanges(
    entityType: string,
    entityId: number,
    pageable: Pageable = { page: 0, size: 10 }
  ): Observable<WrapperPageableResponseEntityChangeDTO> {
    const params = new HttpParams()
      .set('page', String(pageable.page))
      .set('size', String(pageable.size));
    return this.http.get<WrapperPageableResponseEntityChangeDTO>(
      `${this.apiUrl}/audit/${entityType}/${entityId}`,
      { params }
    );
  }

  compareWithPrevious(
    entityType: string,
    entityId: number,
    commitId: string
  ): Observable<WrapperResponseEntityAuditCompareDTO> {
    const params = new HttpParams().set('commitId', commitId);
    return this.http.get<WrapperResponseEntityAuditCompareDTO>(
      `${this.apiUrl}/audit/${entityType}/${entityId}/compare`,
      { params }
    );
  }
}
